import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { FormularioIndividuoConSelect } from '../Components/FormularioIndividuoConSelect'
import { PreguntasFrecuentes } from '../Components/PreguntasFrecuentes'
import { useConfig } from '../../../context/ConfigContext'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

const preguntasFrecuentes = [
    {
        titulo: '¿Qué es un seguro de garantía de alquiler?',
        subTitulo: 'Es una póliza que garantiza al propietario el cobro de alquileres, expensas y otros conceptos del contrato en caso de incumplimiento por parte del inquilino.'
    },
    {
        titulo: '¿Qué diferencia hay entre una garantía de alquiler y una garantía tradicional (por ejemplo, un título de propiedad)?',
        subTitulo: 'La garantía de alquiler es más ágil y accesible. No requiere presentar bienes inmuebles como respaldo y facilita el acceso al alquiler para personas que no cuentan con garantías tradicionales.'
    },
    {
        titulo: '¿Qué cubre exactamente el seguro de garantía de alquiler?',
        subTitulo: 'Cubren el alquiler mensual, expensas comunes, servicios impagos, daños al inmueble, responsabilidad civil y, en algunos casos, los costos judiciales por desalojo.'
    },
    {
        titulo: '¿Quién puede contratar un seguro de garantía de alquiler?',
        subTitulo: 'Tanto particulares como empresas pueden contratar este seguro para respaldar contratos de alquiler de viviendas, oficinas o locales comerciales.'
    },
    {
        titulo: "¿El seguro cubre todo el tiempo que dure el contrato?",
        subTitulo: "Sí, la cobertura acompaña la vigencia del contrato de alquiler, siempre que se cumplan las condiciones pactadas en la póliza."
    }
];

export const GarantiaAlquiler = () => {

    const { config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros Personales y Profesionales - Asegurá tu tranquilidad",
            description: textoSeo?.description ??
                (config.pais === "UY" ?
                    "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Caución · Moto · Hogar · Integral de Comercio · Responsabilidad Civil"
                    :
                    "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular"),
            tituloCompleto: !!textoSeo,
            keywords:
                config.pais === "UY" ?
                    "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro de Responsabilidad Civil, Seguro online, Caución, Aseguradoras, Seguros Sancor, Seguro flota, Cotizar seguro, Seguro San Cristóbal"
                    :
                    "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    : "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar rubro="auto" />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Garantía de Alquiler'
                    url='#formulario'
                    icon='#icon-seg-caucion'
                    subTitulo={{ __html: "Si estás por alquilar una propiedad, asegurá tu contrato con una póliza de garantía de alquiler que te respalde ante cualquier eventualidad y te permita acceder más rápido a tu nuevo hogar o local.<br/><br/>¿Empezamos?" }}
                />
                <div className="pt-70 pt-lg-80 pb-40 bg-primary position-relative">
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                El seguro de garantía de alquiler actúa como respaldo para el propietario y el inquilino, asegurando el cumplimiento de las obligaciones del contrato de alquiler. Los planes pueden incluir:
                            </p>
                        </div>
                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Pago de alquileres:</b> Cubre el pago del alquiler al propietario en caso de que el inquilino no pueda abonar las cuotas pactadas.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Expensas comunes y servicios:</b> Cubre deudas por expensas, impuestos municipales, tarifas de agua, luz, gas y otros servicios esenciales en caso de incumplimiento.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Daños al inmueble:</b> Cubre los daños que el inquilino pueda ocasionar a la propiedad durante el contrato de alquiler, más allá del desgaste habitual.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Gastos de desalojo:</b> Cubre los costos legales asociados a un eventual proceso de desalojo por incumplimiento contractual.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Responsabilidad civil:</b> Ampara reclamos de terceros por daños ocurridos dentro de la propiedad alquilada, atribuibles al inquilino.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FormularioIndividuoConSelect
                    rubro='alquiler'
                    titulo='Cotizá seguro de Garantía de Alquiler'
                />
                <PreguntasFrecuentes
                    faqs={preguntasFrecuentes}
                />
            </div>
        </>
    )
}
